const Style = {
    nav: 'flex items-center  justify-between border-b border-gray-200 py-4 pl-20 pr-10',
    navItems: 'flex items-center gap-4',
    item: 'mr-4 cursor-pointer px-3 py-2 transition duration-200 ease-in-out rounded-2xl hover:bg-slate-200 font-semibold',
    loading: 'opacity-50 mx-12',
}

export default Style